/*
File Name: index.js
Created Date: 2020-05-26 09:25:40
Author: yeyong
Last modified: 2020-06-10 14:25:03
*/
import request from './request.js'
const api = {
    groups: payload => {
        return request.get("/owner_room", { params: payload })
    },
    login: payload => {
        return request.post("/login", payload)
    },
    getChat: payload => {
        return request.get(`/rooms/${payload.id}`, { params: payload })
    },
    getMessage: payload => {
        return request.get("/get_message", { params: payload })
    },
    getRoomInfo: payload => {
        return request.post(`/rooms/${payload.id}`, payload)
    },
    createGroup: payload => {
        return request.post('/create_room', payload)
    },
    getUsers: payload => {
        return request.get('users', { params: payload })
    },
    deleteUser: payload => {
        return request.post(`/rooms/${payload.id}`, payload)
    },
    addUserToRoom: payload => {
        return request.post(`/rooms/${payload.id}`, payload)
    },
    getProjectFile: payload => {
        return request.get("/get_project", { params: payload })
    },
    recallMessage: payload => {
        return request.post(`/rooms/${payload.id}`, payload)
    },
    handleRoomInfo: payload => {
        return request.post(`/rooms/${payload.id}`, payload)
    },
}

export default api
